import {Theme, BreakpointsOptions, PaletteOptions} from "@mui/material";
import {createTheme} from "@mui/material/styles";
import {SimplePaletteColorOptions} from "@mui/material/styles/createPalette";
import {TypographyOptions} from "@mui/material/styles/createTypography";

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        casino: true;
    }
}

interface ExtendedTypographyOptions extends TypographyOptions {
    casino: React.CSSProperties;
}

export const themeConst = {
    "breakpoints": {
        "keys": ["xs", "sm", "md", "lg", "xl"],
        "values": {"xs": 0, "sm": 600, "md": 900, "lg": 1200, "xl": 1536},
        "unit": "px"
    } as BreakpointsOptions,
    "palette": {
        "background": {"default": "#fafafa", "paper": "#fff"},
        "primary": {
            "main": "#d5a332",
            "contrastText": "rgba(255,255,255,0.87)",
            "light": "rgb(221, 181, 91)",
            "dark": "rgb(149, 114, 35)"
        } as SimplePaletteColorOptions,
        "secondary": {
            "main": "#f50057",
            "light": "rgb(247, 51, 120)",
            "dark": "rgb(171, 0, 60)",
            "contrastText": "#fff"
        },
        "common": {"black": "#000", "white": "#fff"},
        "error": {"main": "#d32f2f", "light": "#ef5350", "dark": "#c62828", "contrastText": "#fff"},
        "warning": {"main": "#ed6c02", "light": "#ff9800", "dark": "#e65100", "contrastText": "#fff"},
        "info": {"main": "#0288d1", "light": "#03a9f4", "dark": "#01579b", "contrastText": "#fff"},
        "success": {"main": "#2e7d32", "light": "#4caf50", "dark": "#1b5e20", "contrastText": "#fff"},
        "grey": {
            "50": "#fafafa",
            "100": "#f5f5f5",
            "200": "#eeeeee",
            "300": "#e0e0e0",
            "400": "#bdbdbd",
            "500": "#9e9e9e",
            "600": "#757575",
            "700": "#616161",
            "800": "#424242",
            "900": "#212121",
            "A100": "#f5f5f5",
            "A200": "#eeeeee",
            "A400": "#bdbdbd",
            "A700": "#616161"
        },
        "contrastThreshold": 3,
        "tonalOffset": 0.2,
        "text": {
            "primary": "rgba(0, 0, 0, 0.87)",
            "secondary": "rgba(0, 0, 0, 0.6)",
            "disabled": "rgba(0, 0, 0, 0.38)"
        },
        "divider": "rgba(0, 0, 0, 0.12)",
        "action": {
            "active": "rgba(0, 0, 0, 0.54)",
            "hover": "rgba(0, 0, 0, 0.04)",
            "hoverOpacity": 0.04,
            "selected": "rgba(0, 0, 0, 0.08)",
            "selectedOpacity": 0.08,
            "disabled": "rgba(0, 0, 0, 0.26)",
            "disabledBackground": "rgba(0, 0, 0, 0.12)",
            "disabledOpacity": 0.38,
            "focus": "rgba(0, 0, 0, 0.12)",
            "focusOpacity": 0.12,
            "activatedOpacity": 0.12
        }
    } as PaletteOptions
}

let theme: Theme = createTheme({
    typography: {
        fontFamily: ['Open Sans', 'sans-serif'].join(','),
        body2: {
            fontSize: 13
        },
        h1: {fontSize: '1.625rem', marginTop: 16, marginBottom: 8, fontWeight: 500, textTransform: 'uppercase'},
        h2: {fontSize: '1.5rem', marginTop: 16, marginBottom: 8, fontWeight: 500},
        h3: {fontSize: '1.375rem', marginTop: 16, marginBottom: 8, fontWeight: 400, fontStyle: 'italic'},
        h4: {fontSize: '1.25rem'},
        h5: {fontSize: '1.125rem'},
        h6: {fontSize: '1rem'},
        casino: {fontWeight:700, fontSize: '1.50rem'}
    } as ExtendedTypographyOptions,
    ...themeConst,
    components: {
        // Name of the component
        MuiContainer: {
            styleOverrides: {
                // Name of the slot
                root: ({ownerState, theme}) => ({}),
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        backgroundColor: '#d9c494',
                        color: '#897878'
                    }
                },
            }
        }
    }
});

theme = createTheme(theme, {
    typography: {
        h5: {
            textTransform: 'uppercase',
            color: theme.palette.primary.main
        },
        casino: {
            color: theme.palette.primary.main,
            textShadow: '0.5px 1.5px 0px #000000'
        }
    },
});

export default theme;